import React from 'react';
import styled from 'styled-components';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import MotifIconButton from '@ey/motif-react-wrapper/IconButton';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import {labels} from '../../../util/utils';
import {hardwareIcKeyboardArrowUp24px} from '@ey/motif-react-wrapper/assets/icons';
import {SVGICONS} from '@ey/icons';

export function TimeTrackerPlaceholder(props) {
	const {placeholderMessage, mode} = props;

	return (
		<StyledSectionWrapper className="timetracking-main-wrap-error">
			<MotifTooltip
				contentClassName="timetracking-tooltip-placeholer"
				allowHover={false}
				variant="alt"
				hideCloseButton={true}
				placement="left"
				trigger={
					<MotifIconButton
						className={'clock-available'}
						aria-label="Tooltip"
						type="button"
						onClick={() => {}}
						disabled
						title={'Time-Tracking'}
					>
						<SVGICONS styleName="medium" hoverText={'Time-tracking'} name={'clock-available'} />
					</MotifIconButton>
				}
			>
				<StyledErrorSection className="">{placeholderMessage}</StyledErrorSection>
			</MotifTooltip>
		</StyledSectionWrapper>
	);
}

const StyledErrorSection = styled.section`
	padding: var(--px-15) !important;
	font-size: var(--px-12);
	display: flex;
	align-items: center;
	height: 100%;
`;

const StyledSectionWrapper = styled.section`
	position: absolute;
	bottom: var(--px-10);
	right: 0;
	.clock-available {
		width: var(--px-35);
		height: var(--px-35);
		border-radius: var(--px-4);
		svg {
			width: var(--px-25);
			height: var(--px-25);
			max-width: var(--px-25);
			max-height: var(--px-25);
		}
		&:hover,
		&:focus {
			svg {
				background: transparent;
			}
		}
		&[disabled] {
			svg {
				path {
					fill: var(--neutrals-100) !important;
				}
			}
		}
	}
	.clock-available {
		border-radius: var(--px-4) 0px 0px var(--px-4);
		display: flex;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		width: var(--px-30) !important;
		height: var(--px-60) !important;
		display: flex !important;
		align-items: center;
		justify-content: center;
		background: var(--neutrals-300) !important;
		svg {
			width: var(--px-25);
			height: var(--px-25);
			max-width: var(--px-25);
			max-height: var(--px-25);
		}
		&:hover,
		&:focus {
			svg {
				background: transparent;
			}
		}
	}
	.timetracking-main-wrap-error {
		width: 82%;
		display: flex;
		flex-direction: column;
		margin-left: var(--px-5);
		font-size: var(--px-12);
	}
`;
